const fromdata = [{
		inputdata: "",
		title: "上级",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请选择",
		types: "",
		inputtype: 'cascaderNodeParent',
		width: "350px",
		disabled: false,
		lablewith: '60px',
		btx: false,
	},
	{
		inputdata: "",
		title: "业务员",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请选择",
		types: "",
		inputtype: "selectautocompletes",
		width: "350px",
		btx: true,
		lablewith: '60px',
		options: [],
	},
	{
		inputdata: "",
		title: "省份",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请选择",
		types: "",
		inputtype: "selectMultiple",
		width: "350px",
		btx: true,
		lablewith: '60px',
		options: [],
		disabled: true
	},
	{
		inputdata: "",
		title: "产品线",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请选择",
		types: "",
		inputtype: "select",
		width: "350px",
		btx: true,
		lablewith: '60px',
		options: [],
	},
	{
		inputdata: "",
		title: "显示层级",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "number",
		inputtype: "input",
		width: "325px",
		btx: true,
		lablewith: '75px',
		options: [],
	}
];
export default fromdata;